export const article = {
  id: 14,
  title: "আরোহীর সান্ধ্যগীতি",
  slug: "arohir-sandhyagiti",
  date: "December 2, 2025",
  excerpt: "প্রকৃতির মাহাত্ম্য এবং জীবনের শেষে মৃত্যুকে পরম শান্তি রূপে গ্রহণ করার এক ভাবানুবাদ।",
  content: `![Wandrers Nachtlied](https://s3.ap-south-1.amazonaws.com/sourovroy.me-content/blogs/images/arohi.png)

<div style="display: flex; justify-content: center;">
<div style="text-align: left; font-weight: bold;">

**এসেছে গোধূলি লগ্ন,**  
**পর্বতমালা সন্ন্যাসীসম; গম্ভীর ধ্যানে মগ্ন।**  
**বিদায়ী রবির প্রণতির ধারা; আলোক-স্বর্ণ বুকে—**  
**উদাসী ভূধর শান্ত, স্নিগ্ধ—উচ্ছ্বাস চোখে মুখে।**  
**মৃদু শ্বাস বায়, পাইনের গায়, আর সব যেন থেমে—**  
**মুখর পাখিরা নীরব এখন, সন্ধ্যা আসছে  নেমে।**  
**আর কিছু পথ! আমিও তাহার গেহে,**  
**আরোহন শেষে ঘুমাবো এমনি চিরশান্তির দেহে।**

</div>
</div>

আপাতদৃষ্টিতে প্রকৃতি নির্বিকার। মানুষের অস্তিত্ব; তার সুখ–দুঃখ কিংবা সমস্ত নৈতিক দ্বন্দ্ব সম্পর্কে প্রকৃতি উদাসী। তবুও সমাজ–সংসারে সে কেবল এক প্রেক্ষাপট মাত্র নয়। প্রকৃতি স্বয়ং জীবন্ত এক সত্তা। মানুষকে মুখ্য চরিত্র করে সে আবর্তিত হয় না, কিন্তু সুখে দুঃখে দরকারে অদরকারে যে ভাবেই মানুষ প্রকৃতির কাছে আসে, সে ভাবেই প্রকৃতি তাকে গ্রহণ করে নেয়। প্রকৃতির সঙ্গে মানুষের সম্পর্ক তাই একপ্রকার ঐশ্বরিক। 

তবে প্রকৃতি কেবল দূরে গিয়ে দেখার বিষয় নয়। প্রকৃতির উপস্থিতি সর্বব্যাপী—মানুষের জীবনের মাঝে, মনের মাঝে, ভাষার মাঝে। জীবনের প্রতিটি পদক্ষেপে প্রকৃতি মানুষকে ঋণী করে তোলে। অবশেষে সব দেনা পরিশোধ করে নিতে মৃত্যু আসে। মানুষ আবার ফিরে যায় প্রকৃতির বুকে। ভিন্নভাবে ভাবলে, মানুষ কোনোদিন প্রকৃতি থেকে বিচ্ছিন্ন ছিলই না। 

যে প্রকৃতির এত নৈসর্গিক সৌন্দর্য, যার বিস্তার এত গভীর—তার অবিচ্ছেদ্দ্য অংশ হওয়া এবং অবশেষে তার বুকে মিলিয়ে যাওয়া কেবল দুঃখের ঘটনা বলে আমি মনে করি না। মানুষের জীবনকে পাহাড়ে আরোহণের সঙ্গে তুলনা করে জীবনে আরোহনের প্রচেষ্টাকে ঐশ্বরিক মিলনের রূপে দেখা এবং আরোহনের শেষে মৃত্যুকে পরম শান্তি রূপে গ্রহণ করাই এই লেখার মূল ভাব। 

অনেক দিন আগে জার্মান বিজ্ঞানী এবং কবি গ্যোটের শেষ জীবনে লেখা  "Wandrers Nachtlied II" নামক একটি কবিতা পড়েছিলাম, যার ভাব ছিল কিছুটা এমনই (পুরোটা নয়)। তিনি লিখেছিলেন জার্মানির কিকেলহান পাহাড়ের চূড়ায় বসেl

বিগত ২রা ডিসেম্বর আমি যখন পায়ে হেঁটে ফালুট (পশ্চিমবঙ্গের দ্বিতীয় উচ্চতম শৃঙ্গ) পাহাড়ের চূড়ায় উঠি, উঠতে উঠতে তখন এক অবর্ণনীয় সূর্যাস্ত দেখি। সেই রাতে প্রচণ্ড ঠান্ডায় যখন ঘুম আসছিল না, তখন হাতের কাছে কোনো কাজ না পেয়ে, এই লেখাটি লিখে ফেলি।`,
  author: "সৌরভ রায়",
  readTime: "৩ মিনিট পড়া",
  category: "Philosophy",
  tags: ["দর্শন", "প্রকৃতি", "কবিতা", "গ্যোটে", "মৃত্যু"],
  language: "bengali" as const
};
